import geocode from '../../api/geocode';
import {delay} from 'redux-saga';
import {all, call, takeLatest, put} from 'redux-saga/effects'

import {
  GEOCODE_SET_SEARCH_TERM,
  GEOCODE_SET_SEARCH_RESULTS,
} from './geocodeActions';

function* callGeocodeAPI(action) {
  yield call(delay, 100);
  const results = yield call(geocode, action.payload.searchTerm);
  yield put({ type: GEOCODE_SET_SEARCH_RESULTS, payload: {results}})
}

// Geocode search setup
function* watchGeocodeSearch() {
  yield takeLatest(GEOCODE_SET_SEARCH_TERM, callGeocodeAPI)
}

export default function* geocodeSaga(){
	yield all([
		watchGeocodeSearch(),
	]);
}


// WEBPACK FOOTER //
// ./src/shared/geocode/geocodeSagas.js